import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faSquareMinus, faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import api from "../../services/api";
import EditModal from "../ui/EditModal";
import { normalizar } from "../../common/stringNormalizer";

const filtros = ["todas", "activas", "inactivas"];
const filtroStyle = (activo) => ({
  padding: "6px 16px", border: "none", borderRadius: "20px",
  backgroundColor: activo ? "#d1f5d3" : "#f0f2f5",
  color: activo ? "#075e54" : "#333", fontWeight: activo ? "bold" : "normal",
  boxShadow: activo ? "inset 0 0 0 1px #1ebea5" : "inset 0 0 0 1px #ccc",
  cursor: "pointer", fontSize: "0.9rem"
});

export default function AddEstadosTratamiento() {
  const [Nombre, setNombre] = useState("");
  const [ColorAsociado, setColorAsociado] = useState("#FFFFFF");
  const [estados, setEstados] = useState([]);
  const [filtro, setFiltro] = useState("activas");
  const [editando, setEditando] = useState(null);
  const [CampoAplicacion, setCampoAplicacion] = useState("AMBOS");

  const cargar = async () => setEstados((await api.get("/estados-tratamiento")).data);
  useEffect(() => { cargar(); }, []);

  const guardar = async (e) => {
    e.preventDefault();
    if (estados.some((item) => normalizar(item.Nombre) === normalizar(Nombre))) {
      return Swal.fire("Duplicado", "Ya existe un estado de tratamiento con ese nombre.", "warning");
    }
    try {
      await api.post("/estados-tratamiento", { Nombre, ColorAsociado, CampoAplicacion });
      setNombre(""); setColorAsociado("#FFFFFF"); setCampoAplicacion("AMBOS"); await cargar();
      Swal.fire({ icon: "success", title: "Guardado", timer: 1500, showConfirmButton: false });
    } catch (error) { Swal.fire("Error", error.response?.data?.message || "No se pudo guardar.", "error"); }
  };

  const editar = async (values) => {
    try {
      await api.patch(`/estados-tratamiento/${values.IdEstadoTratamiento}`, values);
      setEditando(null); await cargar();
      Swal.fire({ icon: "success", title: "Estado actualizado", timer: 1500, showConfirmButton: false });
    } catch (error) { Swal.fire("Error", "No se pudo actualizar.", "error"); }
  };

  const alternar = async (id) => {
    await api.patch(`/estados-tratamiento/${id}/estado`);
    await cargar();
  };

  const data = filtro === "todas" ? estados : estados.filter((e) => Number(e.estado) === (filtro === "activas" ? 1 : 0));
  const columnas = [
    { name: "Nombre", selector: (row) => row.Nombre, sortable: true },
    { name: "Asignado a", selector: (row) => ({ CLASIFICACION_INICIO: "Clasificación inicio", RESULTADO: "Resultado", AMBOS: "Ambos" }[row.CampoAplicacion] || "Ambos"), sortable: true },
    { name: "Color Asociado", cell: (row) => <div title={row.ColorAsociado} style={{ width: 25, height: 25, borderRadius: "50%", backgroundColor: row.ColorAsociado }} /> },
    { name: "Editar", cell: (row) => <button className="button is-small is-info" onClick={() => setEditando(row)}><FontAwesomeIcon icon={faPencil} /></button> },
    { name: "Estado", cell: (row) => <FontAwesomeIcon icon={Number(row.estado) === 1 ? faSquarePlus : faSquareMinus} size="2xl" style={{ color: Number(row.estado) === 1 ? "#37ff00" : "#ff0000", cursor: "pointer" }} onClick={() => alternar(row.IdEstadoTratamiento)} /> }
  ];

  return <div className="columns mt-5 is-centered"><div className="column is-half">
    <div className="notification is-primary"><strong>Ingresa el estado de tratamiento</strong></div>
    <form onSubmit={guardar}>
      <div className="field"><label className="label required">Estado Tratamiento</label><div className="control">
        <input className="input" value={Nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Nombre" required />
        <input type="color" value={ColorAsociado} onChange={(e) => setColorAsociado(e.target.value)} /> <span>&lt;--Color del estado</span>
      </div></div>
      <div className="field"><label className="label required">Asignar a</label><div className="select is-fullwidth"><select value={CampoAplicacion} onChange={(e) => setCampoAplicacion(e.target.value)} required><option value="CLASIFICACION_INICIO">Clasificación inicio tratamiento</option><option value="RESULTADO">Resultado del tratamiento</option><option value="AMBOS">Ambos campos</option></select></div></div>
      <button className="button is-success" type="submit">Guardar</button>
    </form>
    <div className="mt-4" style={{ border: "1px solid gray", borderRadius: 8 }}>
      <div style={{ display: "flex", gap: 10, margin: 10 }}>{filtros.map((f) => <button type="button" key={f} style={filtroStyle(filtro === f)} onClick={() => setFiltro(f)}>{f[0].toUpperCase() + f.slice(1)}</button>)}</div>
      <DataTable pagination paginationComponentOptions={{ rowsPerPageText: "Filas por página", rangeSeparatorText: "de" }} columns={columnas} data={data} />
    </div>
    {editando && <EditModal title="Editar Estado Tratamiento" fields={[{ name: "Nombre", label: "Estado Tratamiento", type: "text", required: true }, { name: "ColorAsociado", label: "Color del estado", type: "color", required: true }, { name: "CampoAplicacion", label: "Asignar a", type: "select", required: true, options: [{ label: "Clasificación inicio tratamiento", value: "CLASIFICACION_INICIO" }, { label: "Resultado del tratamiento", value: "RESULTADO" }, { label: "Ambos campos", value: "AMBOS" }] }]} initialValues={{ ...editando, CampoAplicacion: editando.CampoAplicacion || "AMBOS" }} onSubmit={editar} onClose={() => setEditando(null)} />}
  </div></div>;
}
